// js
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';

const NUMERIC_KEYS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-'];

/**
 * Only permits numeric key entry, since Safari and Firefox
 * number inputs allow letters to be typed into them for whatever reason...
 */
class NumericInput extends Component {
  constructor(props) {
    super(props);

    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  isNumeric(key) {
    return NUMERIC_KEYS.includes(key);
  }

  handleKeyPress(event) {
    const { key } = event;
    if (!this.isNumeric(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  render() {
    return (
      <NumberFormat
        {...this.props}
        onKeyPress={this.handleKeyPress}
        data-type='number'
        />
    );
  }
}

export default NumericInput;



// WEBPACK FOOTER //
// ./src/components/common/NumericInput.js